<script lang="ts">
	import type { PoiCategory } from '$lib/components/pois/types';
	import type { PageData } from './$types';
	import { page } from '$app/stores';
	import { getMapLayoutContext } from '$lib/components/map/map-layout-context';
	import PoiFilters from '$lib/components/pois/filters/PoiFilters.svelte';
	import { ROUTE_ON_THE_WAY } from '$lib/constants/route';
	import { getSearchParamsStore, gotoWithParams } from '$lib/services/urls/searchParams';

	const {
		poiMarkerWithDetailsEnabled,
		handlePoiMarkerWithDetailsByFilterChange,
		onAccommodationSelectDates,
		onAccommodationClearDates,
		onMichelinSelectionChange,
	} = getMapLayoutContext();

	const searchParams = getSearchParamsStore();

	export let data: PageData;
	$: ({ poisStore, partnersLinks } = data);
	$: ({ corridorCategory } = $poisStore);

	function handleCategoriesChange(poiCategories: PoiCategory[]) {
		$searchParams.page = 1;
		$searchParams.corridor = { ...$searchParams.corridor, category: poiCategories[0] };
	}

	function onCorridorRadiusChange(radius: number) {
		$searchParams.corridor = { ...$searchParams.corridor, radius };
	}
</script>

<!-- Need an absolute to hide the layout it inherits. TODO: find a way to do this better -->
<div
	class="fixed md:absolute left-0 md:left-2 top-0 h-full w-full md:p-2 md:p-l-0 z-ontop flex flex-col"
>
	<div class="overflow-hidden md:rd-2 max-h-full">
		<PoiFilters
			{partnersLinks}
			forCorridor
			selectedPoiCategories={corridorCategory ? [corridorCategory] : []}
			withPartner={$page.data.hasPartnerAdinmap}
			detailedView={$poiMarkerWithDetailsEnabled}
			class="overflow-x-auto scrollbar-thin bg-neutral-weakest pt-1 md:pt-2 md:rd-2"
			on:goBack={() => {
				// DO NOT USE goBackWithFallback here because we want the filters to persist
				gotoWithParams(ROUTE_ON_THE_WAY, $searchParams);
			}}
			on:poiCategoriesChange={e => handleCategoriesChange(e.detail)}
			on:corridorRadiusChange={e => onCorridorRadiusChange(e.detail)}
			on:selectDates={({ detail }) => {
				onAccommodationSelectDates(detail);
			}}
			on:clearDates={() => {
				onAccommodationClearDates();
			}}
			on:michelinSelectionChange={({ detail: isOnlyMichelin }) => {
				onMichelinSelectionChange(isOnlyMichelin);
			}}
			on:poiFilterChange={handlePoiMarkerWithDetailsByFilterChange}
		/>
	</div>
</div>
